import { render, staticRenderFns } from "./manuManage.vue?vue&type=template&id=9f3064c8&scoped=true"
import script from "./manuManage.vue?vue&type=script&lang=js"
export * from "./manuManage.vue?vue&type=script&lang=js"
import style0 from "./manuManage.vue?vue&type=style&index=0&id=9f3064c8&prod&lang=scss&scoped=true"
import style1 from "./manuManage.vue?vue&type=style&index=1&id=9f3064c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3064c8",
  null
  
)

export default component.exports